// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_10rcn","smallLinkTypography":"_3IZ5t","titleTypography":"_2X4v2","cardTitleTypography":"_2jtV3","truncate":"_3ZYTM","base":"_3GZsi","noBeneficiary":"_3Zzpv","sectionTopHeader":"_126qM","section":"_202P3","sectionTitle":"_3Hdsi","sectionContent":"_1wz74","sectionLoading":"IBsKj","sectionFooter":"_3QjXN","linkButton":"_1fCZ0","button":"_1lYdE","tip":"_348fY","panel":"_2AJpV","line":"_3NIJB","stepStatus":"BT2A8","stepStatus2":"_2wVj4","stepSymbol":"_1tbkt","stepDetails":"ClI1R","stepDetailsGreen":"_1Zv49","actions":"_3wY1k","greenAvatar":"_2VXGl","greyAvatar":"_2UixH"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerPlans/PartnerPlan.scss
// module id = 781
// module chunks = 0